import { render, staticRenderFns } from "./PillJustified.vue?vue&type=template&id=3ffccb7c&"
import script from "./PillJustified.vue?vue&type=script&lang=js&"
export * from "./PillJustified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports